export const SECTIONS = {
  FRONT_LEFT_DOOR: 1,
  BACK_LEFT_DOOR: 2,
  FRONT_RIGHT_DOOR: 3,
  BACK_RIGHT_DOOR: 4,
  FRONT_LEFT_WING: 5,
  BACK_LEFT_WING: 6,
  FRONT_RIGHT_WING: 7,
  BACK_RIGHT_WING: 8,
  BOTTOM_LEFT_DOOR: 9,
  BOTTOM_RIGHT_DOOR: 10,
  FRONT_LEFT_RIM: 11,
  BACK_LEFT_RIM: 12,
  FRONT_RIGHT_RIM: 13,
  BACK_RIGHT_RIM: 14,
  FRONT_WINDSHIELD: 15,
  BACK_WINDSHIELD: 16,
  FRONT_HOOD: 17,
  BACK_TRUNK: 18,
  FRONT_BUMPER: 19,
  BACK_BUMPER: 20,
  FRONT_RIGHT_HEADLIGHTS: 21,
  FRONT_LEFT_HEADLIGHTS: 22,
  BACK_RIGHT_HEADLIGHTS: 23,
  BACK_LEFT_HEADLIGHTS: 24,
  LEFT_WING_MIRROR: 25,
  RIGHT_WING_MIRROR: 26,
  ROOF: 27,
  SADDLERY: 28,
  OTHER: 29
}

export const AREA = {
  FRONT: 1,
  BACK: 2,
  RIGHT_SIDE: 3,
  LEFT_SIDE: 4,
  OTHER: 5
}

export const CirlceSize = {
  FRONT_BACK: '20',
  SIDES: '28'
}
